import React from 'react';
import { motion } from 'framer-motion';
const scattered = ['un schéma clair', 'une fiche', 'quelques exercices', 'une activité courte', 'un contrôle', 'un corrigé'];
export function ProblemBlock() {
  return <section className="w-full bg-white px-5 py-6 sm:py-10" data-id="element-160" data-mp="das79kwei502">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-2xl rounded-2xl border-l-4 border-cobalt bg-cobalt/[0.06] p-5 sm:p-8" data-id="element-161" data-mp="8dicrqu5n35d">
        <h2 className="font-serif-display text-xl font-bold leading-tight text-ink sm:text-2xl" data-id="element-162" data-mp="3qjo9xmt6jnna">
          Construire une séquence ne devrait pas commencer par une heure de recherche.
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-ink/80 sm:text-base" data-id="element-163" data-mp="1oq77cxjwpcze">
          Pour une seule séance, il faut souvent réunir séparément :
        </p>
        <ul className="mt-3 flex flex-wrap gap-2" data-id="element-164" data-mp="qbf0ic8wr9dh">
          {scattered.map(item => <li key={item} className="rounded-full bg-white px-3 py-1 text-[12px] font-medium text-cobalt-deep sm:text-[13px]" data-id="element-165" data-mp="qdrp38968hzi">
              {item}
            </li>)}
        </ul>
        <p className="mt-3 text-sm leading-relaxed text-ink/80 sm:text-base" data-id="element-166" data-mp="lbso250wlx5q">
          Puis refaire les schémas, adapter les supports et assembler le tout, avant même de penser à
          la différenciation.
        </p>
        <div className="mt-4 rounded-xl bg-white p-3 sm:mt-5 sm:p-4" data-id="element-167" data-mp="1dzog2wfj30w6">
          <p className="text-sm font-bold text-cobalt-deep sm:text-base" data-id="element-168" data-mp="zclk4u6ut0ay">
            Le problème n’est pas le manque de ressources. C’est qu’elles sont dispersées.
          </p>
          <p className="mt-2 text-[13px] leading-relaxed text-ink/75 sm:text-sm" data-id="element-169" data-mp="1s0r5nj5qetbu">
            CHIMIE VISUELLE™ réunit théorie visuelle, activités, évaluations et corrigés dans une
            seule bibliothèque, classée par notion : vous choisissez au lieu de recréer.
          </p>
        </div>
      </motion.div>
    </section>;
}